const ruleDialog = {
    methods: {
        alertOnInvalidFields($v, event, reconfirmWithDropdown) {
            // check if selected rule passes validation
            if ($v.$invalid) {
                if (!reconfirmWithDropdown) {
                    // prevent the action from being carried out
                    event.preventDefault();
                    // check for errors other than a lack of compensating factors
                    if ($v.$errors.find(e => e.$property !== 'numberOfFactors')) {
                        // get the invalid fields by checking the rule params and filtering out valid fields
                        // alert user
                        this.$bvModal.msgBoxOk(`WARNING: There are missing or invalid fields. Please check all sections for invalid fields.`);
                    } else {
                        // alert user of missing compensating factors
                        this.$bvModal.msgBoxOk(`WARNING:  With the current type selected, you will not have sufficient valid compensating factors for this exception.`);
                    }
                } else {
                    this.$bvModal.msgBoxOk(`WARNING: There are values missing from the exception form please complete the form before reconfirming.`);
                }
            }
        },
    }
}

const alertMixins = {
    data() {
        return {
            message: null,
            variant: null,
            dismissSecs: 15,
            dismissCountDown: 0
        }
    },

    methods: {
        showAlert(variant, message) {
            // set the variant and message to display
            this.variant = variant;
            this.message = message;
            // Starts the countdown
            this.dismissCountDown = this.dismissSecs;
        },

        countDownChanged(dismissCountDown) {
            // Decrements the countdown
            this.dismissCountDown = dismissCountDown;
        },
    }
}

const dialogMixins = {
    methods: {
        async confirmReset(location) {
            // variable to store display message
            let message;
            if (location === 'save') {
                // set confirmation message for saving scenario with unconfirmed exceptions
                message = "Exceptions that were not reconfirmed or no longer have sufficient compensating factors will be removed. Do you wish to continue?"
            } else if (location === 'Other 1' || location === 'Other 2') {
                // set confirmation message for removing 'Other' comp factor
                message = `Are you sure you want to reset the '${location}' compensating factor?`
            }
            // display message and get the user's response
            const confirmation = await this.$bvModal.msgBoxConfirm(message, {
                okTitle: 'Yes'
            });
            // return the user's response
            return confirmation;
        }
    }
}

export { ruleDialog, alertMixins, dialogMixins };